import React from 'react';
import BarLoader from 'react-spinners/BarLoader';
import Pagination from '../Pagination';
import apiFetch from '../../src/js/fetch';
import Contestant from './Contestant';
import { updatePodium } from '../../src/js/contests/leaderboard';

class ContestShow extends React.Component {
  constructor(props) {
    super(props);

    this.followingFilter = document.querySelector('[name="filterFollowing"]');

    this.state = {
      initialFetched: false,
      segments: props.segments,
      contestId: props.contest_id,
      userId: props.user_id,
      contestants: [],
      loading: true,

      numPages: 1,
      currentPage: 1,
      perPage: null,
      filterFollowing: this.followingFilter?.value || 'all',
    };

    this.currentPositionButton = document.querySelector(
      '[data-current_position]'
    );
  }

  componentDidMount() {
    // Fetch the leaderboard
    this.fetchContestants(this.state.currentPage);

    // Add a global function to reload the leaderboard
    window.reloadLeaderboard = this.reloadLeaderboard;

    // Listen for filter changes
    this.followingFilter.addEventListener('change', this.onChange);

    // Listen for clicks on the current position button that will take the user to the page where the user is
    this.currentPositionButton.addEventListener('click', this.goToPositionPage);
  }

  reloadLeaderboard = () => {
    this.setState({ currentPage: 1, contestants: [], loading: true }, () => {
      this.fetchContestants(this.state.currentPage);
    });
  };

  componentWillUnmount() {
    window.reloadLeaderboard = null;

    this.followingFilter.removeEventListener('change', this.onChange);

    this.currentPositionButton.removeEventListener(
      'click',
      this.goToPositionPage
    );
  }

  goToPositionPage = (e) => {
    const position = this.currentPositionButton.getAttribute(
      'data-current_position'
    );

    window.scrollTo({
      top:
        document.querySelector('.leaderboard').getBoundingClientRect().top +
        window.scrollY -
        100,
      behavior: 'smooth',
    });

    if (position && this.state.perPage) {
      // Calculate the page based on the position
      const page = Math.ceil(parseInt(position) / this.state.perPage);

      console.log({ page, perPage: this.state.perPage, position });
      this.onPaginate(page);
    }
  };

  onPaginate = (page) => {
    if (page !== this.state.currentPage) {
      this.setState({ currentPage: page }, () => {
        this.fetchContestants(page);
      });
    }
  };

  fetchContestants = async (page) => {
    this.setState({ loading: true });

    const { contestId, filterFollowing, initialFetched } = this.state;
    try {
      const data = await apiFetch(`/api/challenges/leaderboard`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          contest_id: contestId,
          page: page,
          filter: {
            following: filterFollowing,
          },
        }),
      });

      console.log({ data });

      this.setState({
        initialFetched: true,
        contestants: data.contestants,
        numPages: data.total_pages,
        perPage: data.per_page,
      });
      if (initialFetched) {
        updatePodium(data.contestants, data.filtered, page, 'segment');
      }
    } catch (e) {
      console.log({ e });
      const err = e.json ? await e.json() : null;
      console.log({ err });

      this.setState({
        loading: false,
        error:
          (err && err.error_message) ||
          'Something went wrong. Please try again later.',
      });
    }
    this.setState({ loading: false });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, currentPage: 1 }, () => {
      this.fetchContestants(1);
    });
  };

  render() {
    const { segments, contestants, numPages, currentPage, userId } = this.state;

    return (
      <div className='w-full leaderboard'>
        <h2 className='mini-label font-medium'>Leaderboard</h2>
        <div className='w-full overflow-x-auto challenge-leaderboard'>
          <table className='w-full border-spacing-y-2 border-separate'>
            <thead className=''>
              <tr className=''>
                <th className=''>#</th>
                <th className=''>Contestant</th>
                {segments.map((segment, i) => (
                  <th key={`${segment.id}`} className='relative items-center'>
                    <span className='inline-flex items-center'>
                      S{i + 1}{' '}
                      <a
                        href={segment.url}
                        className='inline-block pl-1 mini-text text-text-grey-600 whitespace-nowrap underline hover:no-underline underline-offset-2 truncate max-w-[10rem]'
                      >
                        {segment.name}
                      </a>
                    </span>
                  </th>
                ))}
                <th className=''>Points</th>
              </tr>
            </thead>
            <tbody>
              {contestants.map((contestant, i) => (
                <Contestant
                  key={contestant.id}
                  contestant={contestant}
                  segments={segments}
                  userId={userId}
                  index={i}
                />
              ))}
            </tbody>
          </table>

          {this.state.loading ? <BarLoader /> : null}

          <Pagination
            numPages={numPages}
            currentPage={currentPage}
            onPaginate={this.onPaginate}
          />
        </div>
      </div>
    );
  }
}
export default ContestShow;
